export const withAssetPrefix = (filePath) => {
  const prefix = process.env.NEXT_PUBLIC_ASSET_PREFIX
  return `${prefix}/assets/${filePath}`
}
